import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../base/dialog/dialog";
import { StatItemList } from "./stat-item-list";
/**
 * StatListModal - A modal component for displaying a full list of StatListItems
 *
 * Used as a "View All" modal for StatListCard when there are more items than shown in the card.
 */ function StatListModal({ open, onOpenChange, title, items, emptyMessage }) {
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "max-w-md",
            children: [
                /*#__PURE__*/ _jsx(DialogHeader, {
                    children: /*#__PURE__*/ _jsx(DialogTitle, {
                        children: title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "max-h-[60vh] overflow-y-auto",
                    children: /*#__PURE__*/ _jsx(StatItemList, {
                        items: items,
                        emptyMessage: emptyMessage
                    })
                })
            ]
        })
    });
}
export { StatListModal };

//# sourceMappingURL=stat-list-modal.js.map